module.exports = __webpack_public_path__ + "static/media/Pantallas_esp2.eaf6411.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/Pantallas_esp2.mp4
// module id = HVBs
// module chunks = 1